import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import axios from '../../../services/axiosInstance';
import MsgCheckModal from "./MsgCheckModal";

function NaverLoginLoading() {

    const location = useLocation();
    const navigate = useNavigate();

    const [userOutErrorMsg, setUserOutErrorMsg] = useState(false);
    const [mailDuplErrorMsg, setMailDuplErrorMsg] = useState(false);
    const [loginErrorMsg, setLoginErrorMsg] = useState(false);
    const openLoginErrorMsg = (() => {
        setLoginErrorMsg(true);
    })
    const closeLoginErrorMsg = (() => {
        setLoginErrorMsg(false);
        navigate("/UserLoginPg")
    })
    const closeUserOutErrorMsg = () => {
        setUserOutErrorMsg(false);
    }
    const closeMailDuplErrorMsg = () => {
        setMailDuplErrorMsg(false);
    }

    const sendAccessInfo = async (deviceType, id) => {
        try {
            const response = await axios.post('/init/accessInfo', {
                userId: id,
                accessTime: new Date().toISOString(),
                machFl: deviceType
            });
        } catch (error) {
            console.error(error);
        }
    };

    const determineMachFl = () => {
        if (window.navigator.userAgent.includes('ReactNative')) {
            return 'A'; //App
        } else if (window.navigator.userAgent.includes('Mobi')) {
            return 'M'; //웹앱
        } else {
            return 'P'; //PC
        }
    };

    useEffect(() => {

        // UserLoginPg로부터 리다이렉트되면 code와 state가 반환됨
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get('code');
        const state = queryParams.get('state');

        const fetchData = async () => {
            try {
                // code와 state를 가지고 백엔드에서 네이버유저 찾아서 로그인시키고 토큰반환
                const response = await axios.get(`/externalApi/naverLogin`, { params: { code, state : state } });
                const data = response.data;
                if (data.loginErrorType === '0') {
                    console.log('이용이 정지된 계정입니다');
                    setUserOutErrorMsg(true);
                    return;
                } else if (data.loginErrorType === '1') {
                    console.log('다른 수단으로 가입된 계정입니다');
                    setMailDuplErrorMsg(true);
                    return;
                }

                localStorage.setItem('AToken', response.headers['authorization']);
                // 저장형식은 ISO 로 통일한다 (Date 객체를 그대로 넣으면 브라우저 기본 문자열이 들어간다)
                localStorage.setItem('lastLoginTime', new Date().toISOString());
                const userEmail = data.email;
                const deviceType = determineMachFl();
                await sendAccessInfo(deviceType, userEmail);
                // 로그인 전 페이지로 이동
                let redirectTo = sessionStorage.getItem("redirectAfterLogin") || "/";
                sessionStorage.removeItem("redirectAfterLogin");
                navigate(redirectTo);
            } catch (error) {
                console.log('네이버로그인 최종단계오류 : ', error);
                openLoginErrorMsg();
            }
        };

        if (state.length === 16 && code) {
            fetchData();
        } else {
            openLoginErrorMsg();
        }


    }, []);


    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                color: '#fff',
            }}>
                <div style={{
                    border: '4px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '50%',
                    borderTop: '4px solid #fff',
                    width: '50px',
                    height: '50px',
                    marginRight: '10px',
                    animation: 'spin 2s linear infinite',
                }}></div>
            </div>


            { loginErrorMsg ?
                <MsgCheckModal loginErrorMsg={loginErrorMsg} closeLoginErrorMsg={closeLoginErrorMsg}/>
                :
                userOutErrorMsg ?
                    <MsgCheckModal userOutErrorMsg={userOutErrorMsg} closeUserOutErrorMsg={closeUserOutErrorMsg}/>
                    :
                    mailDuplErrorMsg ?
                        <MsgCheckModal mailDuplErrorMsg={mailDuplErrorMsg} closeMailDuplErrorMsg={closeMailDuplErrorMsg}/>
                        :
                null
            }
        </div>
    );
}

export default NaverLoginLoading;
